import { COMPONENTS } from "../lib/constants";

export const MainViewGrid = {
  size: 100,
  gap: 1,
  name: "main",
  padding: {
    top: 5,
    bottom: 5,
    left: 5,
    right: 5,
    landscape: {
      top: 3,
      bottom: 0,
      left: 5,
      right: 5,
    },
    portrate: {
      top: 3,
      bottom: 3,
      left: 3,
      right: 3,
    },
  },
  main: [
    {
      name: "empty",
      size: 3,
    },
    {
      name: "leftgrid",
      size: 65,
      type: "PortrateGridController",
      config: {
        name: "leftgrid",
        size: 100,
        gap: 0,
        align: "left",
        main: [
          {
            name: "logogrid",
            type: "LandscapeGridController",
            size: 14,
            config: {
              size: 100,
              gap: 1,
              name: "logogrid",
              main: [
                {
                  name: COMPONENTS.LOGO,
                  size: 34,
                  align: "bottom_left",
                  bounds: {
                    width: 203,
                    height: 140,
                  },
                },
                {
                  name: "empty",
                  size: 39,
                },
                {
                  name: COMPONENTS.QUEST_WIDGET,
                  size: 28,
                  bounds: {
                    width: 310,
                    height: 70,
                  },
                },
              ],
            },
          },
          //   {
          //     name: "empty",
          //     size: 1,
          //   },
          {
            name: COMPONENTS.REEL,
            bounds: {
              width: 1144,
              height: 680,
              offsetY: -8,
            },
            // height: 90,
            size: 75,
          },
        ],
      },
    },
    {
      name: "empty",
      size: 3,
    },
    {
      name: "rightgrid",
      size: 25,
      type: "PortrateGridController",
      config: {
        name: "leftgrid",
        size: 100,
        gap: 0,
        align: "left",
        padding: {
          left: 12,
        },
        main: [
          {
            name: "empty",
            size: 4,
          },
          {
            name: COMPONENTS.INFO_BUTTONS,
            size: 9,
            // height: 80,
            align: "top_right",
            bounds: {
              width: 180,
              height: 100,
            },
          },
          {
            name: "empty",
            size: 1,
          },
          {
            name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
            size: 25,
            align: "bottom_left",
            bounds: {
              width: 380,
              height: 200,
            },
          },
          {
            name: "empty",
            size: 2,
          },
          {
            name: COMPONENTS.BONUS_BUY_WIDGET,
            size: 13,
            align: "left",
            bounds: {
              width: 380,
              height: 112,
            },
          },
          {
            name: "empty",
            size: 0.5,
          },
          {
            name: COMPONENTS.BET_AMOUNT,
            align: "left",
            size: 14,
            bounds: {
              width: 375,
              height: 112,
            },
          },
          // {
          // 	name: 'empty',
          // 	size: 1
          // },
          {
            name: COMPONENTS.SPIN_BUTTONS,
            align: "top_left",
            size: 15,
            bounds: {
              width: 375,
              height: 106,
            },
          },
          //   {
          //     name: "empty",
          //     size: 24,
          //   },
        ],
      },
    },
  ],
  landscape: [
    {
      name: "leftgrid-landscape",
      size: 65,
      type: "PortrateGridController",
      config: {
        name: "leftgrid-landscape",
        size: 100,
        gap: 0,
        align: "left",

        main: [
          {
            name: "logogridp-landscape",
            type: "LandscapeGridController",
            size: 15,
            align: "left",
            config: {
              size: 100,
              gap: 1,
              unhide: [
                "quest_widget_bg",
                "FTR_QUEST_TITLE",
                "FTR_QUEST_SUBTITLE",
                "FTR_QUEST_TIMER",
              ],
              name: "logogrid",
              main: [
                {
                  name: COMPONENTS.LOGO,
                  size: 33,
                  align: "bottom_left",
                  bounds: {
                    width: 203,
                    height: 140,
                  },
                },
                {
                  name: "empty",
                  size: 17,
                },
                {
                  name: COMPONENTS.QUEST_WIDGET,
                  size: 44,
                  bounds: {
                    width: 310,
                    height: 70,
                  },
                },
              ],
            },
          },

          {
            name: COMPONENTS.REEL,
            bounds: {
              width: 1144 / 2,
              height: 680 / 2,
              // offsetY: -30
            },
            // height: 90,
            size: 75,
          },
        ],
      },
    },
    {
      name: "empty",
      size: 3,
    },
    {
      name: "rightgrid",
      size: 30,
      type: "PortrateGridController",
      config: {
        name: "leftgrid_bhdbcjksbdcjksbndcjknslkcns",
        size: 100,
        gap: 2,
        unhide: ["double_chance_widget_bg_mobile"],
        hide: ["double_chance_widget_fg", "double_chance_widget_bg"],
        align: "left",
        padding: {
          left: 12,
        },
        main: [
          {
            name: "empty",
            size: 5,
          },
          {
            name: COMPONENTS.INFO_BUTTONS,
            size: 14,
            // height: 80,
            align: "top_right",
            bounds: {
              width: 180,
              height: 100,
            },
          },
          {
            name: "empty",
            size: 5,
          },
          {
            name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
            size: 14,
            align: "left",
            bounds: {
              width: 380,
              height: 102,
            },
          },
          {
            name: "empty",
            size: 1,
          },
          {
            name: COMPONENTS.BONUS_BUY_WIDGET,
            size: 14,
            align: "left",
            bounds: {
              width: 380,
              height: 102,
            },
          },
          {
            name: "empty",
            size: 2,
          },
          {
            name: COMPONENTS.BET_AMOUNT,
            align: "left",
            size: 14,
            bounds: {
              width: 347,
              height: 108,
            },
          },
          {
            name: COMPONENTS.SPIN_BUTTONS,
            align: "top_left",
            size: 16,
            bounds: {
              width: 380,
              height: 116,
            },
          },
        ],
      },
    },
  ],
  portrate: [
    {
      name: "uppanel-portrait",
      size: 10,
      type: "LandscapeGridController",
      config: {
        size: 100,
        gap: 0,
        maxWidth: "reel",
        name: "logogrid-portrait",
        hide: [
          "quest_widget_bg",
          "FTR_QUEST_TITLE",
          "FTR_QUEST_SUBTITLE",
          "FTR_QUEST_TIMER",
          "double_chance_widget_bg",
          "double_chance_widget_fg_mobile",
        ],
        unhide: ["double_chance_widget_bg_mobile"],
        main: [
          {
            name: COMPONENTS.LOGO,
            size: 24,
            align: "left",
            bounds: {
              // width: 300 / 2,
              // height: 254 / 2,

              width: 216,
              height: 92,
            },
          },
          // {
          //   name: COMPONENTS.QUEST_WIDGET,
          //   size: 25,
          //   // align: "center",
          //   bounds: {
          //     offsetX: 0,
          //     offsetY: 5,
          //     width: 210 / 2,
          //     height: 210 / 2,
          //   },
          // },
          {
            name: "empty",
            size: 35,
          },
          {
            name: COMPONENTS.INFO_BUTTONS,
            size: 34,
            align: "right",
            bounds: {
              width: 180,
              height: 100,
              offsetY: 10,
            },
          },
        ],
      },
    },
    {
      name: "empty",
      size: 4,
    },
    {
      name: COMPONENTS.REEL,
      bounds: {
        width: 1144 / 2,
        height: 680 / 2,
      },
      align: "top",
      size: 33,
    },
    {
      name: "empty",
      //name: "bottompanel",
      size: 10.2,
    },
    {
      name: "bonuspanel",
      size: 11,
      type: "LandscapeGridController",
      config: {
        size: 100,
        gap: 0,
        maxWidth: "reel",
        hide: ["double_chance_widget_fg"],
        name: "bonusbuy",
        main: [
          // { name: "empty", size: 15 },
          {
            name: COMPONENTS.DOUBLE_CHANCE_WIDGET,
            size: 49,
            align: "right",
            bounds: {
              width: 393,
              height: 112,
            },
          },
          {
            name: "empty",
            size: 2,
          },
          {
            name: COMPONENTS.BONUS_BUY_WIDGET,
            size: 49,
            align: "right",
            bounds: {
              width: 393,
              height: 112,
              offsetX: 5,
            },
          },
          // { name: "empty", size: 15 },
        ],
      },
    },
    // { name: 'empty', size: 1 },
    {
      name: COMPONENTS.BET_AMOUNT,
      size: 11,
      bounds: {
        width: 400,
        height: 108,
      },
    },
    {
      name: COMPONENTS.SPIN_BUTTONS,
      size: 17,
      bounds: {
        width: 400,
        height: 170,
        // offsetX: -20,
      },
    },
    {
      name: "empty",
      size: 8,
    },
  ],
};
